import { Component, OnInit } from '@angular/core';
import { VproService } from "src/app/service/vpro/vpro.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Utils } from 'src/app/common/utils';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import Swal from "sweetalert2";
import { Router } from "@angular/router";
import { AllPatient } from 'src/app/models/patient';
@Component({
  selector: 'app-appointments-patient',
  templateUrl: './appointments-patient.component.html',
  styleUrls: ['./appointments-patient.component.css']
})
export class AppointmentsPatientComponent implements OnInit {

  public appointments: any;
  dateFormat = Utils.DATE_FORMAT; // default date format from constants
  findAppointmentForm: UntypedFormGroup;
  totalMembers = [];
  constructor(private service: VproService, private spinner: NgxSpinnerService, private _formBuilder: UntypedFormBuilder, private router: Router) { }
  patient: AllPatient;
  ngOnInit() {
    this.getPatient();
    this.findAppointmentForm = this._formBuilder.group({
      pid: [null],
      apDate: [null]
    });

  }

  getPatient() {
    this.spinner.show();
    this.service.getPatientById(localStorage.getItem("uid"), '?fields=members').subscribe(res => {
      this.spinner.hide();
      this.fetchMembers(res);
      this.patchPatientValues();
    }, err => {
      this.spinner.hide();
    });
  }


  fetchMembers(data) {
    if (!data.members || data.members.length === 0) data.members = [];
    this.totalMembers = data.members;
    this.patient = this.totalMembers && this.totalMembers.length > 0 ? null : null;
  }


  patchPatientValues() {
    if (this.patient) {

      // bind form values
      let valuesToBind = ['first_name', 'last_name', 'pid'];
      let patchVal = {};
      for (let val of valuesToBind) {
        if (this.patient[val]) patchVal[val] = this.patient[val];
      }
      this.findAppointmentForm.patchValue(patchVal);
    }
  }

  getPatientAppointments() {
    let val = this.findAppointmentForm.value;
    let data = {};

    if (val.pid) {
      data['pid'] = parseInt(val.pid);
    }

    if (val.apDate) {
      data['apdate'] = val.apDate.year + "-" + val.apDate.month + "-" + val.apDate.day
    }

    this.spinner.show();
    this.service.getPatientAppointments(data).subscribe(res => {
      this.spinner.hide();
      this.appointments = res;
      if (this.appointments && this.appointments.length > 0) {
        this.appointments.forEach((aptime) => {
          if (aptime) aptime.aptime = Utils.formatTime(aptime.aptime);
        });
      }
    }, err => {
      this.spinner.hide();
      this.appointments.length = 0;
    })

  }

  goToPrescription(apt) {
    // check if appointment status is approval requested, scheduled or not completed
    if (apt && apt.schedule_stat) {
      if ([Utils.APPOINTMENT_STATUS.APPROVAL_REQUESTED, Utils.APPOINTMENT_STATUS.SCHEDULED, Utils.APPOINTMENT_STATUS.NOT_COMPLETED].includes(apt.schedule_stat)) {
        // show alert
        Swal.fire({
          position: "top",
          type: "success",
          title: "Consultation summary not available",
          showConfirmButton: false,
          timer: 1700,
        });

      } else {
        // route to prescription page
        this.router.navigate([`/patient/consultation/${apt.aptid}`],);
      }
    }
  }

}
